import { Component, OnInit } from '@angular/core';
import { MASKS } from 'ng-brazil';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ServicoEntregaService } from 'src/app/services/servico-entrega.service';
import { ServicoEntrega } from 'src/app/models/servico-entrega';

@Component({
  selector: 'app-cadastrar-servico-entrega',
  templateUrl: './cadastrar-servico-entrega.component.html',
  styleUrls: ['./cadastrar-servico-entrega.component.scss']
})
export class CadastrarServicoEntregaComponent implements OnInit {
  idServicoEntrega;
  servicoEntrega = new ServicoEntrega();
  public MASKS = MASKS;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private router: Router,
    private carregandoService: CarregandoService,
    private servicoEntregaService: ServicoEntregaService) { }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idServicoEntrega = this.route.snapshot.paramMap.get('id');
      this.buscarServicoEntrega();
    } else {
      this.servicoEntrega = new ServicoEntrega();
    }
  }

  buscarServicoEntrega() {

    this.carregandoService.mostra('buscarServicoEntrega');

    this.servicoEntregaService.consultarPorIdServicoEntrega(this.idServicoEntrega).subscribe(serv => {
      this.servicoEntrega = serv;

      this.carregandoService.esconde('buscarServicoEntrega');
    }, (erro) => {
      this.carregandoService.esconde('buscarServicoEntrega');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaServicoEntrega');

    this.servicoEntrega.de = Number(this.servicoEntrega.de);
    this.servicoEntrega.ate = Number(this.servicoEntrega.ate);
    this.servicoEntrega.valor = Number(this.servicoEntrega.valor);

    this.servicoEntregaService.salvar(this.servicoEntrega).subscribe(() => {
      this.notificacaoService.sucesso('Serviço de Entrega salvo com sucesso!!!');
      this.router.navigate(['configuracoes/servico-entrega']).then(() => {
        this.carregandoService.esconde('salvaServicoEntrega');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaServicoEntrega');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }
}
